import type { TabsListProps } from './types'
import styles from './Tabs.module.css'

/**
 * Container para os botões de aba.
 * Card branco com bordas arredondadas.
 */
export function TabsList({ children, className, 'aria-label': ariaLabel }: TabsListProps) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel || 'Abas de navegação'}
      className={[styles.tabsList, className].filter(Boolean).join(' ')}
    >
      {children}
    </div>
  )
}
